import type { HandlingItemRow, TariffRateRow, WarehouseFields } from './fixtures';

/** V1 warehouse subtotals, recalculated from the current draft on every render. */
export function warehouseWithTotals(
  warehouse: WarehouseFields,
  charges: TariffRateRow[],
  handling: HandlingItemRow[],
): WarehouseFields {
  const dray = charges
    .filter((c) => c.scope === 'transloadquote' && c.rateType === 'IN RATE')
    .reduce((total, c) => total + (Number(c.rate) || 0), Number(warehouse.drayRate) || 0);
  const handled = handling
    .filter((h) => h.rateType === 'IN RATE' && h.unitType === warehouse.drayHandlingUnitType)
    .reduce((total, h) => total + (Number(h.rate) || 0), Number(warehouse.drayHandlingCharge) || 0);
  return { ...warehouse, drayWithCharges: dray.toFixed(5), handlingWithCharges: handled.toFixed(5) };
}
